import React from 'react';

import './Post.css';

const post = props => {
	return (
		<article className="Post" onClick={props.clicked}>
			<h1 className="Title">{props.title}</h1>
			<div className="PostNumber">{props.postNumber}</div>
		</article>
	);
};

export default post;



// WEBPACK FOOTER //
// ./src/components/Post/Post.js